export const baseUrl = "https://api.nasa.gov/planetary/apod"

export const key = process.env.REACT_APP_APOD_API_KEY;